interface StructuredDataProps {
  type: "website" | "webpage" | "organization" | "breadcrumb";
  data?: any;
}

export function StructuredData({ type, data }: StructuredDataProps) {
  const getStructuredData = () => {
    const baseData = {
      "@context": "https://schema.org",
    };

    switch (type) {
      case "website":
        return {
          ...baseData,
          "@type": "WebSite",
          name: "Stellar Blade Mods",
          alternateName: ["StellarMods", "Stellar Blade Modifications", "SB Mods"],
          url: "https://stellarblademod.com/",
          description: "Premium Stellar Blade mod sharing community. Discover quality-tested modifications for enhanced gameplay, character customization, graphics, and performance optimization.",
          inLanguage: "en-US",
          copyrightYear: new Date().getFullYear(),
          copyrightHolder: {
            "@type": "Organization",
            name: "Stellar Blade Mods Community"
          },
          potentialAction: {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://stellarblademod.com/search?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          },
          sameAs: [
            "https://discord.gg/stellarblademods",
            "https://twitter.com/stellarblademods"
          ],
          keywords: "stellar blade mods, gaming modifications, character customization, graphics enhancement, performance optimization",
          audience: {
            "@type": "Audience",
            audienceType: "Gamers and Modding Enthusiasts"
          }
        };

      case "organization":
        return {
          ...baseData,
          "@type": "Organization",
          name: "Stellar Blade Mods",
          legalName: "Stellar Blade Mods Community",
          url: "https://stellarblademod.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://stellarblademod.com/logo.png",
            width: 512,
            height: 512
          },
          image: "https://stellarblademod.com/og-image.jpg",
          description: "Community-driven platform for premium Stellar Blade game modifications. We curate and share quality-tested mods for enhanced gaming experience.",
          foundingDate: "2024",
          slogan: "Premium mods, curated with passion",
          knowsAbout: [
            "Game Modifications",
            "Stellar Blade",
            "Gaming Community",
            "Software Enhancement",
            "Digital Content Curation"
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
            url: "https://stellarblademod.com/contact",
            availableLanguage: "English"
          },
          sameAs: [
            "https://discord.gg/stellarblademods",
            "https://twitter.com/stellarblademods"
          ]
        };

      case "webpage":
        return {
          ...baseData,
          "@type": "WebPage",
          name: data?.title || "Stellar Blade Mods - Premium Mod Sharing Community",
          description: data?.description || "Discover premium Stellar Blade mods curated by passionate players. Quality-tested modifications for enhanced gameplay experience.",
          url: data?.url || "https://stellarblademod.com/",
          inLanguage: "en-US",
          datePublished: data?.datePublished || new Date().toISOString(),
          dateModified: new Date().toISOString(),
          author: {
            "@type": "Organization",
            name: "Stellar Blade Mods Community"
          },
          publisher: {
            "@type": "Organization",
            name: "Stellar Blade Mods",
            logo: {
              "@type": "ImageObject",
              url: "https://stellarblademod.com/logo.png"
            }
          },
          isPartOf: {
            "@type": "WebSite",
            name: "Stellar Blade Mods",
            url: "https://stellarblademod.com/"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://stellarblademod.com/og-image.jpg",
            width: 1200,
            height: 630
          }
        };

      case "breadcrumb":
        return {
          ...baseData,
          "@type": "BreadcrumbList",
          itemListElement: data?.items?.map((item: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: item.url
          })) || [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
                             item: "https://stellarblademod.com/"
            }
          ]
        };

      default:
        return baseData;
    }
  };

  const structuredData = getStructuredData();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
} 